import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const ColumnChart = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 64 64" {...props}>
    <path
      fill={getColor(color, isColorInherited)}
      d="M6,44v12v2h2h6h2v-2V44v-2h-2H8H6V44z M14,44v12H8V44H14z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M20,32v24v2h2h6h2v-2V32v-2h-2h-6h-2V32z M28,32v24h-6V32H28z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M34,20v36v2h2h6h2v-2V20v-2h-2h-6h-2V20z M42,20v36h-6V20H42z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M48,8v48v2h2h6h2v-2V8V6h-2h-6h-2V8z M56,8v48h-6V8H56z"
    />
  </SvgIcon>
);
